import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, concatMap, catchError } from 'rxjs/operators';

import { AccountClientService } from '@mode/shared/data-access-webapp';
import * as EmailAdminActions from './email-admin.actions';

@Injectable()
export class EmailAdminEffects {
  public emailAdmin$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(EmailAdminActions.emailAdmin),
      concatMap(({ username, adminId, message }) => this._accountClientService.emailAdmin(username, adminId, message)),
      map((response) => EmailAdminActions.emailAdminSuccess(response)),
      catchError((error) => of(EmailAdminActions.emailAdminFailure(error)))
    );
  });

  constructor(
    private _actions$: Actions,
    private _accountClientService: AccountClientService
  ) {}
}
